import { Button, Dropdown, Form, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';

const MyDropDown2 = (props) => {
  console.log(props, " = props:MyDropDown2");
  const { selectedValue, items=[], onChange, isBtnShow = true, className, size = "large", borderRadius="10px" } = props;
  // const [value, setValue] = useState(selectedValue);

  // console.log(value, " = vaaaaaaaalllllllllliiiiiuuuueeeeee", selectedValue);
  
  const handleMenuClick = (e) => {
    onChange(e.key);
    // setValue(e.key);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {items?.map(item => (
        <Menu.Item key={item.key}>{item.label}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      placement="bottom"
      className={`w-full flex justify-start items-center bg-pureWhite ${className}`}
      size={size}
    >
      {isBtnShow ?
        <Button size={size} style={{ borderRadius: borderRadius }} className="flex items-center w-full justify-between">
          <span>{selectedValue}</span>
          <DownOutlined />
        </Button>
        :
        <div>
          <span className='cursor-pointer'>{selectedValue}</span>
          <DownOutlined />
        </div>
      }
    </Dropdown>
  );
}

export default MyDropDown2;
